<template>
  <div id="faqs" class="faqs">
    <div class="faqs_cont">
      <div class="faqs_left">
        <div class="left_title">{{ $t('home.faqs.title') }}</div>
        <div class="left_text">{{ $t('home.faqs.text') }}</div>
      </div>
      <div class="faqs_right">
        <div class="right_cont">
          <div class="right_ques">
            <div class="right_ques_li" :class="{active: item.show}" v-for="item in questionList" @click="item.show = !item.show">
              <div class="ques_li_title" >{{ item.title }}</div>
              <div class="ques_li_text" v-show="item.show && item.text1">
                <p>{{ item.text1  }}</p>
                <p>{{ item.text2  }}</p>
                <p>{{ item.text3  }}</p>
                <p>{{ item.text4  }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed, watch } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'faqs',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const questionList = ref([
        {
          show: false,
          title: t('home.faqs.ques_title1'),
          text1: t('home.faqs.ques_text1')
        },
        {
          show: false,
          title: t('home.faqs.ques_title2'),
          text1: t('home.faqs.ques_text2_1'),
          text2: t('home.faqs.ques_text2_2'),
          text3: t('home.faqs.ques_text2_3'),
          text4: t('home.faqs.ques_text2_4')
        },
        {
          show: false,
          title: t('home.faqs.ques_title3'),
          text1: t('home.faqs.ques_text3_1'),
          text2: t('home.faqs.ques_text3_2'),
          text3: t('home.faqs.ques_text3_3')
        },
        {
          show: false,
          title: t('home.faqs.ques_title4'),
          text1: t('home.faqs.ques_text4')
        },
        {
          show: false,
          title: t('home.faqs.ques_title5'),
          text1: t('home.faqs.ques_text5')
        },
        {
          show: false,
          title: t('home.faqs.ques_title6'),
          text1: t('home.faqs.ques_text6_1'),
          text2: t('home.faqs.ques_text6_2'),
          text3: t('home.faqs.ques_text6_3'),
          text4: t('home.faqs.ques_text6_4')
        },
        {
          show: false,
          title: t('home.faqs.ques_title7'),
          text1: t('home.faqs.ques_text7')
        },
        {
          show: false,
          title: t('home.faqs.ques_title8'),
          text1: t('home.faqs.ques_text8')
        },
        {
          show: false,
          title: t('home.faqs.ques_title9'),
          text1: t('home.faqs.ques_text9')
        }
      ])
      watch(lan, (newValue) => {
        questionList.value = [
          {
            show: false,
            title: t('home.faqs.ques_title1'),
            text1: t('home.faqs.ques_text1')
          },
          {
            show: false,
            title: t('home.faqs.ques_title2'),
            text1: t('home.faqs.ques_text2_1'),
            text2: t('home.faqs.ques_text2_2'),
            text3: t('home.faqs.ques_text2_3'),
            text4: t('home.faqs.ques_text2_4')
          },
          {
            show: false,
            title: t('home.faqs.ques_title3'),
            text1: t('home.faqs.ques_text3_1'),
            text2: t('home.faqs.ques_text3_2'),
            text3: t('home.faqs.ques_text3_3')
          },
          {
            show: false,
            title: t('home.faqs.ques_title4'),
            text1: t('home.faqs.ques_text4')
          },
          {
            show: false,
            title: t('home.faqs.ques_title5'),
            text1: t('home.faqs.ques_text5')
          },
          {
            show: false,
            title: t('home.faqs.ques_title6'),
            text1: t('home.faqs.ques_text6_1'),
            text2: t('home.faqs.ques_text6_2'),
            text3: t('home.faqs.ques_text6_3'),
            text4: t('home.faqs.ques_text6_4')
          },
          {
            show: false,
            title: t('home.faqs.ques_title7'),
            text1: t('home.faqs.ques_text7')
          },
          {
            show: false,
            title: t('home.faqs.ques_title8'),
            text1: t('home.faqs.ques_text8')
          },
          {
            show: false,
            title: t('home.faqs.ques_title9'),
            text1: t('home.faqs.ques_text9')
          }
        ]
      })
      return {
        lan,
        questionList
      };
    }
  })
</script>

<style scoped lang="scss">
.faqs {
  width: 1200px;
  margin: auto;
  box-sizing: border-box;
  .faqs_cont {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .faqs_left {
      width: 145px;
      .left_title {
        font-size: 30px;
        font-weight: 600;
        line-height: 40px;
        margin-bottom: 20px;
        letter-spacing: 0.05em;
        color: rgba(3, 255, 145, 1);
      }
      .left_text {
        font-size: 20px;
        font-weight: 500;
        line-height: 32px;
        letter-spacing: 0em;
        color: rgba(43, 179, 106, 1);
      }
    }
    .faqs_right {
      width: 1026px;
      height: 406px;
      // padding: 20px;
      border-radius: 30px;
      box-sizing: border-box;
      background: url(../assets/faq_bg.png) no-repeat 100%/100%;
      .right_cont {
        margin: 20px;
        width: 986px;
        height: 366px;
        overflow: hidden;
        .right_ques {
          width: 1003px;
          height: 366px;
          display: flex;
          overflow: auto;
          flex-direction: column;
          align-items: flex-start;
          .right_ques_li {
            padding: 20px;
            cursor: pointer;
            margin-bottom: 6px;
            border-radius: 30px;
            box-sizing: border-box;
            background: linear-gradient(86.6deg, rgba(47, 67, 55, 0.612) 5.45%, rgba(46, 81, 60, 0.27) 97.19%);
            &:last-child {
              margin-bottom: 0;
            }
            &.active {
              .ques_li_title {
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
              }
              .ques_li_text {
                font-size: 14px;
                font-weight: 400;
                margin-top: 16px;
                line-height: 24px;
                letter-spacing: 0em;
                color: rgba(255, 255, 255, 0.88);
              }
            }
            .ques_li_title {
              font-size: 16px;
              font-weight: 500;
              line-height: 21px;
              letter-spacing: 0em;
              color: rgba(43, 179, 106, 1);
            }
          }
        }
      }
      
    }
  }
}


@media screen and (max-width: 1200px) {
  .faqs {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .faqs_cont {
      display: flex;
      flex-direction: column;
      .faqs_left {
        width: 100%;
        margin-bottom: 20px;
      }
      .faqs_right {
        width: 100%;
        height: 252px;
        background: url(../assets/faq_bg.png) no-repeat 100%/100%;
        background-size: 100% 240px;
        .right_cont {
          width: 95%;
          height: 210px;
          .right_ques {
            width: 103%;
            height: 210px;
          }
        }
      }
    }
  }
}
</style>